import styled from 'styled-components';
import { Stack } from '@mui/material';
import { neutrals } from 'utils/styles/color';

export const StyledInvoiceTableDetails = styled(Stack)`
  && {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .MuiBox-root {
      display: flex;
      gap: 5px;
      .MuiTypography-body2 {
        font-family: 'Poppins', sans-serif;
        font-size: 0.75rem;
        font-weight: 400;
        line-height: 16px;
        text-align: right;
        color: ${neutrals[700]};
      }

      .MuiTypography-body2:first-of-type {
        width: 100px;
      }
    }
  }
`;
